import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.scss";

// components
import Admin from "../views/Admin/component";
import Login from "../views/Login/container";
import VerificationCode from "../views/VerificationCode/container";
import Account from "../views/Account/container";
import Onborading from "../views/Onborading/container";
import DeepLink from "../views/DeepLink/component";
import ShowDetails from "../views/ShowDetails/container.js";
import NewShow from "../views/NewShow/container";
import { Navigate } from "react-router-dom";
import Notification from "../views/Notification/container";
import NewShowFromArt19Component from "../views/NewShowFromArt19/container";
import NewShowFromMegaphone from "../views/NewShowFromMegaphone/container";
import NewPremiumShowFromMegaphone from "../views/NewPremiumShowFromMegaphone/container";
// import MegaphoneShows from "../views/MegaphoneShows/container";
// import MegaphoneDetail from "../views/MegaphoneDetail/container.js";

const PrivateRoute = ({ children }) => {
  return localStorage.getItem("Authorization") ? (
    children
  ) : (
    <Navigate to="/login" />
  );
};

function App(props) {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login {...props} />} />
        <Route path="/login" element={<Login {...props} />} />
        <Route path="/verify-code" element={<VerificationCode {...props} />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/account/profile" element={<Account {...props} />} />
        <Route
          path="/shows"
          element={
            <PrivateRoute>
              <Onborading {...props} />
            </PrivateRoute>
          }
        />
        <Route
          path="/app-home-screen"
          element={
            <PrivateRoute>
              <Onborading {...props} />
            </PrivateRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <PrivateRoute>
              <Onborading {...props} />
            </PrivateRoute>
          }
        />
        <Route
          path="/show-details/:id"
          element={
            <PrivateRoute>
              <ShowDetails {...props} />
            </PrivateRoute>
          }
        />
        <Route path="/deeplink/:id" element={<DeepLink {...props} />} />
        <Route path="/deeplink/shows/:id" element={<DeepLink {...props} />} />
        <Route
          path="/episode-season/:id"
          element={
            <PrivateRoute>
              <ShowDetails {...props} />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-shows"
          element={
            <PrivateRoute>
              <NewShow {...props} />
            </PrivateRoute>
          }
        />
        <Route
          path="/upload-season-or-episodes/:id"
          element={
            <PrivateRoute>
              <ShowDetails {...props} />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-push-notification"
          element={
            <PrivateRoute>
              <Notification {...props} />
            </PrivateRoute>
          }
        />
        <Route
          path="/new-show-from-art-19"
          element={
            <PrivateRoute>
              <NewShowFromArt19Component {...props} />
            </PrivateRoute>
          }
        />

        <Route
          path="/new-show-from-megaphone"
          element={
            <PrivateRoute>
              <NewShowFromMegaphone {...props} />
            </PrivateRoute>
          }
        />

        <Route
          path="/premium-show-from-megaphone"
          element={
            <PrivateRoute>
              <NewPremiumShowFromMegaphone {...props} />
            </PrivateRoute>
          }
        />

        {/* <Route
          
          path="/megaphone-shows"
          element={
            <PrivateRoute>
              <MegaphoneShows {...props} />
            </PrivateRoute>
          }
        />
        <Route
          
          path="/megaphone-app-home-screen"
          element={
            <PrivateRoute>
              <MegaphoneShows {...props} />
            </PrivateRoute>
          }
        />
        <Route
          
          path="/megaphone-categories"
          element={
            <PrivateRoute>
              <MegaphoneShows {...props} />
            </PrivateRoute>
          }
        />

        <Route
          
          path="/megaphone-show-details/:id"
          element={
            <PrivateRoute>
              <MegaphoneDetail {...props} />
            </PrivateRoute>
          }
        />
        <Route
          
          path="/megaphone-episode-season/:id"
          element={
            <PrivateRoute>
              <MegaphoneDetail {...props} />
            </PrivateRoute>
          }
        />
        <Route
          
          path="/megaphone-upload-season-or-episodes/:id"
          element={
            <PrivateRoute>
              <MegaphoneDetail {...props} />
            </PrivateRoute>
          }
        /> */}
      </Routes>
    </Router>
  );
}

export default App;
